import modules from './modules'
import actions from './actions'

export default ({ initialized, items, shipping, payment, checkout, coupon }) => {
  items = items || []
  coupon = coupon || null
  checkout = checkout || false

  return {

    namespaced: true,

    modules: {
      shipping: modules.shipping(shipping || {}),
      payment: modules.payment(payment || {})
    },

    state: {
      items,
      loading: false,
      initialized,
      checkout,
      coupon
    },

    // mutating the state
    // mutations are always synchronous
    mutations: {

      setItems (state, items) {
        state.items = items
        state.initialized = true
      },

      setLoading (state, { loading }) {
        state.loading = loading
      },

      coupon (state, { coupon }) {
        state.coupon = coupon
      }

    },

    // commits the mutation, it's asynchronous
    // use actions for performing server requests without blocking
    // application while waiting for the response
    actions,

    // showing things, not mutating state
    getters: {

      shipping: (state, getters) => state.shipping.data ? (getters.brutto >= state.shipping.data.freeShipping ? 0 : state.shipping.data.options[state.shipping.option].amount) : 0,
      brutto_discounted: (state, getters) => (state.items.reduce((accumulator, current) => accumulator + parseFloat(current.qty) * parseFloat(current.price), 0) - getters.coupon_discount),
      brutto: state => state.items.reduce((accumulator, current) => accumulator + parseFloat(current.qty) * parseFloat(current.brutto_price), 0),
      coupon_discount: state => state.coupon  && state.coupon.is_whole ? state.coupon.discount_amount : (state.coupon  && state.coupon.is_absolute_procentage ? state.coupon.discount_amount : 0),
      discount: (state, getters) => getters.brutto - getters.brutto_discounted,
      total: (state, getters) => getters.brutto_discounted + getters.shipping,
      tax: (state, getters) => getters.brutto_discounted - getters.netto,
      netto: (state, getters) => getters.brutto_discounted / ((100 + App.lang.$t('app.vat')) / 100),
      count: state => state.items.length

    }
  }
}
